<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-YiDianZan`]" width="1em" height="1em" v-bind="$attrs"><g clip-path="url(#svg_45117d9737__clip0_18957_5982)"><path d="M5.00016 2.6665C2.97512 2.6665 1.3335 4.30814 1.3335 6.33317C1.3335 9.99984 5.66683 13.3332 8.00016 14.1086C10.3335 13.3332 14.6668 9.99984 14.6668 6.33317C14.6668 4.30814 13.0252 2.6665 11.0002 2.6665C9.76006 2.6665 8.66373 3.28214 8.00016 4.22444C7.3366 3.28214 6.24026 2.6665 5.00016 2.6665Z" stroke="#000" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="svg_45117d9737__clip0_18957_5982"><path d="M0 0H16V16H0z"/></clipPath></defs></svg>
</template>
<script>

export default {
  name: 'IconYiDianZan',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
